import { TemplateRef } from '@angular/core';
import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
import { MenuModel } from '../menu/menu.model';
export class ToolbarModel extends CoreModel {
/**
 * Toolbar type. Can be: info, warning, error.
 */
type?: string;
/**
 * Optional info section.
 */
info?: {
    /**
     * To show / hide info section.
     */
    show?: boolean;
    /**
     * IconModel data for info icon.
     */
    icon?: IconModel;
    /**
     * Order of info section. Means flex system order property. Order numbers can be: 0, 1, 2, 3, 4, 5, 6.
     */
    order?: number;
  };
/**
 * Optional content section.
 */
content?: {
    /**
     * To show / hide toolbar content section.
     */
    show?: boolean;
    /**
     * Title for content section.
     */
    title?: string;
    /**
     * Toolbar template.
     */
    template?: TemplateRef<any>;
    /**
     * Order of content section. Means flex system order property. Order numbers can be: 0, 1, 2, 3, 4, 5, 6.
     */
    order?: number;
  };
/**
 * Optional actions section.
 */
actions?: {
    /**
     * To show / hide actions section.
     */
    show?: boolean;
    /**
     * MenuModel component for actions section.
     */
    menu?: MenuModel;
    /**
     * Order of actions section. Means flex system order property. Order numbers can be: 0, 1, 2, 3, 4, 5, 6.
     */
    order?: number;
  }
/**
 * Optional close icon section.
 */
close?: {
    /**
     * To show / hide close icon section.
     */
    show?: boolean;
    /**
     * IconModel data for close icon.
     */
    icon?: IconModel;
    /**
     * Order of close icon section. Means flex system order property. Order numbers can be: 0, 1, 2, 3, 4, 5, 6.
     */
    order?: number;
  };
/**
 * Optional help icon section.
 */
help?: {
    /**
     * To show / hide help icon section.
     */
    show?: boolean;
    /**
     * IconModel data for help icon.
     */
    icon?: IconModel;
    /**
     * Order of help icon section. Means flex system order property. Order numbers can be: 0, 1, 2, 3, 4, 5, 6.
     */
    order?: number;
  };
/**
 * Optional maximize/minimize icons section.
 */
maximization?: {
    /**
     * To show / hide maximize/minimize icons section.
     */
    show?: boolean;
    /**
     * Whether toolbar must be maximized.
     */
    maximized?: boolean;
    /**
     * IconModel data for minimizeIcon.
     */
    minimizeIcon?: IconModel;
    /**
     * IconModel data for maximizeIcon.
     */
    maximizeIcon?: IconModel;
    /**
     * Order of maximize/minimize icons section. Means flex system order property. Order numbers can be: 0, 1, 2, 3, 4, 5, 6.
     */
    order?: number;
  };
/**
 * Optional expandable icon section.
 */
expandable?: {
    /**
     * To show / hide expandable icon section.
     */
    show?: boolean;
    /**
     * To set toolbar to be expanded.
     */
    expanded?: boolean;
    /**
     * IconModel data for expandable icon.
     */
    icon?: IconModel;
    /**
     * Order of expandable icon section. Means flex system order property. Order numbers can be: 0, 1, 2, 3, 4, 5, 6.
     */
    order?: number;
  }
/**
 * It is the constructor for the ToolbarModel component. It takes the values to create the ToolbarModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function ToolbarModel_tsickle_Closure_declarations() {
/**
 * Toolbar type. Can be: info, warning, error.
 * @type {?}
 */
ToolbarModel.prototype.type;
/**
 * Optional info section.
 * @type {?}
 */
ToolbarModel.prototype.info;
/**
 * Optional content section.
 * @type {?}
 */
ToolbarModel.prototype.content;
/**
 * Optional actions section.
 * @type {?}
 */
ToolbarModel.prototype.actions;
/**
 * Optional close icon section.
 * @type {?}
 */
ToolbarModel.prototype.close;
/**
 * Optional help icon section.
 * @type {?}
 */
ToolbarModel.prototype.help;
/**
 * Optional maximize/minimize icons section.
 * @type {?}
 */
ToolbarModel.prototype.maximization;
/**
 * Optional expandable icon section.
 * @type {?}
 */
ToolbarModel.prototype.expandable;
}

